import React from "react";
import "../css/privacy.scss";

function Cookies() {
  return (
    <div className="page-width page-width--narrow section-template--27768163107198__main-padding">
      <h1 className="main-page-title page-title h0">Cookie Policy</h1>
      <div className="rte">
        <p>Last updated: 14 September 2026</p>
        <p>This policy explains how pittleforestandco uses cookies and similar technologies when you visit our website.</p>
        <strong>WHAT COOKIES ARE</strong>
        <p>Cookies are small text files stored on your device. They help websites remember settings, keep shopping carts working and understand how pages are used.</p>
        <strong>COOKIES WE USE</strong>
        <p><b>Strictly necessary cookies</b> support core functions such as security, page navigation, checkout and the shopping cart. These cannot be disabled through our site.</p>
        <p><b>Preference cookies</b> remember choices that improve your visit, such as selected options.</p>
        <p><b>Analytics cookies</b> help us understand website performance and usage in aggregated form. Where required, we use them only after consent.</p>
        <p><b>Marketing cookies</b> may measure campaigns or tailor advertising. Where required, they are used only after consent.</p>
        <strong>YOUR CHOICES</strong>
        <p>You can accept, reject or manage non-essential cookies when a consent control is available. You can also block or delete cookies in your browser settings, although this may affect site functionality.</p>
        <strong>THIRD-PARTY SERVICES</strong>
        <p>Some service providers may set cookies when they provide checkout, payment, security or analytics functions. Their handling of information is governed by their own notices.</p>
        <strong>CHANGES AND CONTACT</strong>
        <p>We may update this policy when our practices or legal requirements change. Questions can be sent to round@pittleforestandco.shop.</p>
      </div>
    </div>
  );
}

export default Cookies;
